























import Vue from "vue";
import { PersistedEventInterface } from "@/types";
import moment from "moment-timezone";
import { marked } from "marked";

export default Vue.extend({
  props: {
    event: {
      type: Object as () => PersistedEventInterface,
      required: true,
    },
  },
  computed: {
    localDate(): string {
      const utcDate = moment.tz(this.formattedDate, this.event.date.timezone);

      return utcDate
          .clone()
          .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
          .format("dddd, MMMM Do YYYY, HHmm [hours]");
    },
    formattedDate(): string {
      return this.event.date ? this.event.date.date.substring(0, 23) : "";
    },
    renderedDescription(): string {
      if (!this.event.description) {
        return "";
      }
      return marked.parse(this.event.description, { async: false }) as string;
    },
  },
  methods: {
    redirectToEvent() {
      this.$router.push(`/events/${this.event.name}`);
    },
  },
});
